export const DAD_PARTNERS_DOCTRINE = {
  promise: "Choose courage, receive brotherhood.",
  currentCondition:
    "Dads may be present in the room but still stretched thin, guarded, discouraged, or unsure whether it is safe to be honest.",
  homeProof:
    "Look for calmer presence, more intentional time, better listening, more play, repaired conflict, and family-visible steadiness.",
  gemWriterVoice: {
    audience:
      "Write for a guarded dad who may be burned out by church programs.",
    leadWith: [
      "Rest",
      "Connection",
      "Honest companionship",
      "Practical human application",
    ],
    avoid: [
      "Shame",
      "Fear-based framing",
      "Pressure",
      "Accountability language",
      "Preachy, corporate, or church-program tone",
    ],
    scriptureBoundary:
      "Use approved Scripture as context only. Do not quote, restate, paraphrase, complete, or modify it; write only the human application.",
  },
  weeklyRhythms: [
    "Self-care",
    "Connection with wife",
    "One-on-one time with each child",
    "Guide Partner story",
    "Guide Prompt focus",
    "Wins check-in",
  ],
};

export const DAD_PARTNERS_DOCTRINE_FIELDS = [
  "current_condition_note",
  "home_proof_signal",
  "weekly_rhythm_signal",
];
